import { useCountry } from '@increasecard/increase-core';

export default function usePaymentRequired() {
  const country = useCountry();

  return country !== 'dominicana';
}
